import "./ResponsibleSkillGames.css";
import Navbar from "../../components/Navbar/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
const ResponsibleSkillGames = () => {
  return (
    <div>
      <Navbar />
      <div className="terms-container">
        <h1>Skill Game</h1>
        <p>
          <strong>Last updated:</strong> December 24th, 2024
        </p>

        <h2>Introduction</h2>
        <p>
          Bullz.games is a brand operated by <strong>XENOM GROUP</strong>, a
          Limited Company registered under the laws of Anjouan with registration
          number 15739 and headquarters located at Hamchako, Mutsamudu, Anjouan.
          References in this policy to "the Company," "We," or "Our" mean XENOM
          GROUP.
        </p>

        <h2>Responsible Participation and Self-Control</h2>

        <h3>Responsible Participation</h3>
        <p>
          Engaging in skill games is meant to provide a stimulating and
          enjoyable experience for users. However, we recognize that excessive
          participation may lead to unintended consequences for some individuals.
          Our goal is to promote a balanced and positive interaction with our
          platform.
        </p>
        <p>
          We have implemented various measures to help users maintain control
          over their participation and make informed decisions. These efforts
          include educational resources and tools to support self-regulation.
        </p>

        <h3>Information and Contact</h3>
        <p>
          Our Support team is available to assist you via email at any time:
        </p>
        <ul>
          <li>Email: <a href="mailto:contact@bullz.games">contact@bullz.games</a></li>
        </ul>

        <h3>Helpful Hints for Balanced Play</h3>
        <p>
          Follow these guidelines to ensure your experience remains enjoyable
          and well-balanced:
        </p>
        <ul>
          <li>
            <strong>Set participation limits:</strong> Allocate a reasonable
            amount of time and resources based on your schedule and priorities.
          </li>
          <li>
            <strong>Avoid over-engagement:</strong> Take regular breaks to
            maintain focus and prevent fatigue.
          </li>
          <li>
            <strong>Focus on skill improvement:</strong> Treat your gameplay as
            a way to enhance your skills and have fun, rather than focusing
            solely on outcomes.
          </li>
          <li>
            <strong>Play mindfully:</strong> Avoid engaging in games when you are
            stressed, distracted, or under the influence of alcohol, drugs, or
            medication.
          </li>
          <li>
            <strong>Use a single account:</strong> Keep track of your progress
            and activities by consolidating them into one account.
          </li>
        </ul>

        <h3>Minor Protection</h3>
        <p>
          You must be 18 years or older to use our platform. To safeguard minors
          in your household, ensure your login credentials are secure and
          consider using internet filters.
        </p>

        <h3>Self-Exclusion</h3>
        <p>
          If you feel the need to step back, our self-exclusion feature allows
          you to take a break for a defined period (6 months to 5 years). During
          this time, creating a new account will not be permitted. To activate
          self-exclusion, contact our support team:
        </p>
        <ul>
          <li>Email: <a href="mailto:contact@bullz.games">contact@bullz.games</a></li>
        </ul>
        <p>
          Self-exclusion is a commitment for the selected duration and cannot be
          reversed to ensure your well-being.
        </p>

        <h2>Contact Us</h2>
        <p>
          For any questions about responsible play, reach out to us at
          <a href="mailto:contact@bullz.games">contact@bullz.games</a>.
        </p>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ResponsibleSkillGames;
